import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../../../components/hooks/useAuth";


const PrivateMenuUp = () => {

  const { HandleSideBar, sidebarOpen, user, signOut } = useAuth();

  const HEADER_HEIGHT = 56;
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: HEADER_HEIGHT,
        background: "#005c53", // alterado para a nova cor
        zIndex: 1200,
        borderRadius: 0,
        marginLeft: 0,
      }}
    >
      <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
        <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Dashboard</span>
      </div>
      <div className="ms-auto d-flex align-items-center pe-3">
        <div className="dropdown">
          <a
            href="#"
            className="nav-link d-flex align-items-center p-0"
            id="userDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ color: "#fff", cursor: "pointer" }}
          >
            <i
              className="bi bi-person-circle"
              style={{
                fontSize: 28,
                // Removido qualquer estilo de hover
              }}
            ></i>
            <span
              className="d-none d-lg-inline ms-2"
              style={{
                padding: "6px 16px",
                borderRadius: 16,
                transition: "background 0.2s",
                display: "inline-block",
              }}
            >
              {user?.name || "Usuário"}
            </span>
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
            <li>
              <a className="dropdown-item" href="/Editarperfil">Perfil</a>
            </li>

            <li>
              <a className="dropdown-item" href="#">Treinamentos</a>
            </li>

            <li>
              <a className="dropdown-item" href="#">Termos de uso</a>
            </li>

            <li>
              <a className="dropdown-item" href="#" onClick={e => signOut()}>Sair</a>
            </li>
          </ul>
        </div>
      </div>
    </nav >
  );
};

export default PrivateMenuUp;
